import { Type } from '@angular/core';
import { BlockTypeModel } from './block-type.model';
import { DisplayElementModel } from './display-element.model';
import { FormFieldModel } from './form-field.model';
import { LayoutBlockTypesEnum } from './block.model';


export class LayoutBlockType extends BlockTypeModel {

    disableDropCondition: (blockType: BlockTypeModel) => boolean;

    constructor(
        key: string,
        label: string,
        icon: string,
        twig: string,
        displayElementType: Type<DisplayElementModel>,
        fields: FormFieldModel[],
        componentType?: Type<any>,
        isDashboard?: boolean,
        disableDropCondition?: (blockType: BlockTypeModel) => boolean
    ) {
        super(
            key,
            label,
            icon,
            twig,
            displayElementType,
            fields,
            componentType,
            isDashboard,
        );

        this.disableDropCondition = disableDropCondition;
    }

    clone(): LayoutBlockType {
        const clone = super.clone() as LayoutBlockType;
        clone.disableDropCondition = this.disableDropCondition;

        return clone;
    }
}

export const layoutBlockTypes = [
    LayoutBlockTypesEnum.distributionOne,
    LayoutBlockTypesEnum.briefingOne,
    LayoutBlockTypesEnum.distributionTwo,
    LayoutBlockTypesEnum.briefingTwo,
    LayoutBlockTypesEnum.distributionThree,
    LayoutBlockTypesEnum.briefingThree
];
